import { ReactNode } from "react"
import { cn } from "~/common/cn"

interface StyledTextProps {
  children: ReactNode
  variant?: "default" | "stroke" | "inter-small"
  className?: string
}

export function StyledText({
  children,
  variant = "default",
  className = "",
}: StyledTextProps): JSX.Element {
  const baseClasses = "font-md-nichrome font-bold uppercase max-md:tracking-[0.02em]"
  const sizeClasses =
    "text-[min(16vw,6rem)] md:text-[min(8.0vw,7.85rem)] leading-[0.9] md:leading-[0.9]"
  const variantClasses = variant === "stroke" ? "stroke-text" : ""

  return <span className={cn(baseClasses, sizeClasses, variantClasses, className)}>{children}</span>
}
